var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeeValueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3726",
    "data-name": "Rectangle 3726",
    width: 50,
    height: 60,
    transform: "translate(73 2059)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_580",
    "data-name": "Mask Group 580",
    transform: "translate(-73 -2059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-pro-31",
    transform: "translate(73 2064.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M39.655.9l-3.988,16h.2a8.451,8.451,0,0,0,3.773-16",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M35.863,0a8.448,8.448,0,1,0-.2,16.894L39.655.9A8.406,8.406,0,0,0,35.863,0",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M48.977,23.225a3.478,3.478,0,0,0-2.482-1.03h0a3.5,3.5,0,0,0-2.479,1.022l-6.893,6.829H34.63a3.524,3.524,0,0,0,.2-1.132,3.644,3.644,0,0,0-3.512-3.837H23.047l-1.618,6.47-2.056,8.243H35.924a3.493,3.493,0,0,0,2.486-1.03L48.973,28.2a3.52,3.52,0,0,0,0-4.969",
    fill: "#3bc1d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M20.6,28.986h1.468l.981-3.931H12.914a3.539,3.539,0,0,0-2.482,1.03L.268,36.248c-.46.456-.238.921,0,1.664,0,0,3.071,10.779,3.3,11.013a1.181,1.181,0,0,0,1.664,0l9.134-9.134h5l2.052-8.243.377-1.509H20.6Z",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M34.826,28.986H22.067L21.8,30.038H34.63a2.188,2.188,0,0,0,.189-1.053",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M19.226,28.986v1.053H21.8l.264-1.053Z",
    fill: "#3bc1d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M28.3,8.183l-3.973,16h.2a8.447,8.447,0,0,0,3.773-16",
    fill: "#f6911e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M24.523,7.285a8.448,8.448,0,1,0-.2,16.894l3.969-16a8.406,8.406,0,0,0-3.773-.9",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M25.1,19.777V20.8a.223.223,0,0,1-.219.219h-.513a.219.219,0,0,1-.219-.219v-.981a9.579,9.579,0,0,1-1.558-.151c-.185-.034-.208-.075-.208-.2v-.449a.17.17,0,0,1,.185-.174h.034c.5.045,1.3.1,1.8.1,1.309,0,1.656-.543,1.656-1.309,0-.543-.317-.849-1.309-1.46L23.7,15.536c-1-.611-1.509-1.166-1.509-2.041,0-1.132.709-1.743,1.962-1.886v-.947a.219.219,0,0,1,.219-.219H24.9a.223.223,0,0,1,.219.219v.905a15.388,15.388,0,0,1,1.588.143c.109.019.189.075.189.185v.468a.17.17,0,0,1-.189.174h0c-.483-.034-1.245-.1-1.886-.1-1.132,0-1.6.26-1.6,1.056,0,.513.377.819,1.188,1.32l1,.6c1.264.755,1.709,1.351,1.709,2.222a2.057,2.057,0,0,1-1.992,2.139",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M24.9,21.312h-.528a.513.513,0,0,1-.513-.513V20.1a9.809,9.809,0,0,1-1.317-.147.464.464,0,0,1-.449-.487v-.449a.464.464,0,0,1,.479-.468h.064c.517.045,1.29.1,1.777.1,1.256,0,1.362-.524,1.362-1.015,0-.377-.17-.592-1.17-1.207l-1.056-.645c-1-.6-1.668-1.219-1.668-2.29a2.067,2.067,0,0,1,1.962-2.15v-.683a.513.513,0,0,1,.528-.513H24.9a.513.513,0,0,1,.513.513v.626c.513.026,1.026.083,1.339.128a.487.487,0,0,1,.411.479v.468a.464.464,0,0,1-.472.464h-.306c-.453-.034-1.075-.079-1.588-.079-1.219,0-1.309.317-1.309.755,0,.343.223.573,1.045,1.068l1,.6c1.332.792,1.852,1.509,1.852,2.475A2.275,2.275,0,0,1,25.4,20.033v.773a.513.513,0,0,1-.5.506Zm-.453-.589h.377v-1.2l.253-.034a1.744,1.744,0,0,0,1.739-1.849c0-.656-.257-1.188-1.566-1.969l-1-.6c-.781-.472-1.332-.86-1.332-1.573,0-1.188.958-1.351,1.886-1.351.536,0,1.17.045,1.63.079h.158v-.245c-.377-.049-.951-.109-1.509-.128H24.8V10.737h-.377v1.132l-.257.034c-1.132.14-1.705.664-1.705,1.6,0,.7.377,1.185,1.362,1.788l1.079.634c1.026.63,1.452,1,1.452,1.709,0,1.079-.638,1.6-1.95,1.6-.475,0-1.2-.045-1.724-.091v.234a9.235,9.235,0,0,0,1.479.14h.287Z",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M36.444,12.491v1.026a.219.219,0,0,1-.215.219h-.513a.219.219,0,0,1-.219-.219v-.981a9.485,9.485,0,0,1-1.543-.155c-.185-.03-.208-.075-.208-.2v-.445a.17.17,0,0,1,.185-.177h.023c.5.045,1.3.1,1.8.1,1.309,0,1.66-.543,1.66-1.305,0-.547-.317-.853-1.309-1.46l-1.06-.645c-1-.611-1.509-1.166-1.509-2.037,0-1.132.709-1.747,1.962-1.886V3.4a.215.215,0,0,1,.219-.215h.5a.215.215,0,0,1,.226.215V4.3a15.468,15.468,0,0,1,1.592.143.176.176,0,0,1,.185.185V5.1a.166.166,0,0,1-.185.174h0c-.483-.03-1.245-.1-1.886-.1-1.132,0-1.6.264-1.6,1.06,0,.509.377.815,1.192,1.317l1,.6c1.268.755,1.713,1.354,1.713,2.226a2.055,2.055,0,0,1-2,2.135",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M36.218,14.031h-.5a.513.513,0,0,1-.513-.513v-.69a9.292,9.292,0,0,1-1.317-.147.464.464,0,0,1-.449-.487v-.453a.464.464,0,0,1,.479-.472h.057c.551.049,1.313.1,1.773.1,1.26,0,1.366-.524,1.366-1.015,0-.377-.17-.6-1.17-1.211L34.886,8.5c-.988-.6-1.645-1.222-1.645-2.29A2.063,2.063,0,0,1,35.2,4.059V3.4a.509.509,0,0,1,.513-.528h.5a.509.509,0,0,1,.521.528v.626c.517.03,1.026.083,1.343.132a.479.479,0,0,1,.434.475V5.1a.46.46,0,0,1-.479.468h-.324c-.472-.034-1.064-.079-1.573-.079-1.215,0-1.309.317-1.309.755,0,.34.226.57,1.049,1.068l1,.6c1.336.8,1.856,1.49,1.856,2.479a2.276,2.276,0,0,1-2,2.384v.777A.513.513,0,0,1,36.218,14.031Zm-.438-.589h.358V12.235L36.4,12.2a1.741,1.741,0,0,0,1.739-1.845c0-.66-.257-1.192-1.566-1.973l-.992-.6c-.781-.472-1.336-.86-1.336-1.569,0-1.192.962-1.354,1.886-1.354.532,0,1.132.045,1.618.079h.17V4.693a14.665,14.665,0,0,0-1.509-.132H36.12V3.456h-.358V4.588l-.26.03c-1.132.14-1.7.668-1.7,1.607,0,.7.377,1.181,1.362,1.784l1.056.645c1.022.63,1.449,1.007,1.449,1.713,0,1.075-.638,1.6-1.95,1.6-.479,0-1.2-.045-1.72-.091v.234a9.141,9.141,0,0,0,1.475.143h.29Z",
    fill: "#e2ded6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeValueIcon);
export default __webpack_public_path__ + "static/media/fee-value-icon.786329e80bcff8f09dfd0f5895e11caf.svg";
export { ForwardRef as ReactComponent };